// src/components/TZMMS-INV/api/tzmmsInvApi.js
// ============================================================================
// TZMMS Inventory Counter — frontend API wrappers
// ----------------------------------------------------------------------------
// PURPOSE
// - Keep all frontend -> backend calls in one file.
// - Return normalized shapes so the hook stays simple.
// ============================================================================

import axios from '../../../axiosClient.js';

// ============================================================================
// BLOCK TZI.API.001 — Small normalization helpers
// ============================================================================
function trimStr(value) {
  return typeof value === 'string' ? value.trim() : String(value ?? '').trim();
}

function asObject(value) {
  return value && typeof value === 'object' ? value : {};
}

// ============================================================================
// BLOCK TZI.API.002 — Send inventory list email
// ----------------------------------------------------------------------------
// INPUT
// - to: email recipient
// - subject: email subject line
// - message: plain-text body
//
// OUTPUT
// - Normalized { success, error? } object
// ============================================================================
export async function sendInventoryEmail({ to, subject, message }) {
  const payload = {
    to: trimStr(to), // Trim userEmail so blank-space values do not pass validation.
    subject: trimStr(subject), // Keep subject formatting consistent.
    message: trimStr(message), // Backend expects plain text.
  };

  const { data } = await axios.post('/api/tzmms-inv/send-email', payload);
  const safeData = asObject(data);

  return {
    success: Boolean(safeData.success), // Preserve backend success flag.
    error: trimStr(safeData.error || ''), // Normalize optional error text.
  };
}
